<div>
  <p-select
    placeholder="{{ 'common.select' | translate | titlecase }}"
    [options]="profileStatuses"
    [style]="{ width: '100%' }"
    [(ngModel)]="selectedStatusId"
    appendTo="body"
  >
  </p-select>
  <p>{{ 'profiles.search.set-status-note' | translate }}</p>
</div>
